var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidApk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 12",
    "aria-hidden": "true",
    role: "img",
    className: "icon icon-android sm margin square VIconSvgGradient_icon_WJLeK",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6c8d13",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#9bce04",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54 4.637v3.095c0 .411-.324.74-.736.74-.408 0-.804-.331-.804-.74V4.637c0-.404.396-.735.804-.735.404 0 .735.331.735.735zm.288 4.196a.79.79 0 00.791.791h.532l.008 1.633c0 .986 1.475.978 1.475 0V9.624h.995v1.633c0 .98 1.483.984 1.483 0V9.624h.54a.788.788 0 00.785-.791V4.038H1.828v4.795zm6.628-5.054H1.8c0-1.144.684-2.138 1.7-2.657L2.987.18c-.075-.13.115-.214.179-.101l.519.951a3.61 3.61 0 012.894 0l.517-.95c.067-.115.254-.03.179.102l-.51.94c1.007.519 1.691 1.513 1.691 2.657zM3.894 2.296a.28.28 0 00-.28-.28.277.277 0 00-.273.28c0 .152.123.28.272.28a.28.28 0 00.281-.28zm3.03 0a.279.279 0 00-.272-.28.28.28 0 100 .56c.15 0 .273-.128.273-.28zm2.534 1.606a.733.733 0 00-.735.735v3.095c0 .411.332.74.735.74.412 0 .805-.331.805-.74V4.637c0-.412-.396-.735-.805-.735z",
    fill: "url(#grad1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidApk);
export default __webpack_public_path__ + "static/media/android-apk.c99006eef2e20d979e899602f1f35c80.svg";
export { ForwardRef as ReactComponent };